if ($( window ).width() >= 1199)
{
    function toggleMenu(e) {
        if ($(this).hasClass('menu-active')) {
            $('.parent-sub').removeClass('menu-active');
        } else {
            $('.parent-sub').removeClass('menu-active');
            $('.show-sub-menu').removeClass('show-sub-menu');
            $(this).addClass('menu-active');
        }
        $(this).find('.sub-menu').toggleClass('show-sub-menu');
        $(this).find('.sub-sub-menu').removeClass('sub-active');
    }

    $(".parent-sub").hover(toggleMenu);
    $(".parent-sub").keydown(function (ev) {
        if (ev.which == 13) {
            toggleMenu.call(this, ev);
        }
    });


    $( ".sub-sub-menu").hover(
        function() {
            $(this).toggleClass('sub-active');
            let heightOfList = $(this).closest('ul').outerHeight();
            let secondList = $(this).find('.js-show > ul').outerHeight();
            if(secondList > heightOfList){
                let heightOfList = secondList + 'px';
                $(this).find('.js-show > ul').css('height', heightOfList);
            }else{
                $(this).find('.js-show > ul').css('height', heightOfList + 'px');
            }
        }
    );

    $(".sub-sub-menu").on('mouseenter mouseleave', function (e) {
        if ($(this).length) {
            let val = 0;
            let widthOfList = $(this).find('.js-show > ul').outerWidth();
            let widthOfSecondList = $(this).outerWidth();
            var elm = $(this).find('ul:first');
            var off = elm.offset();
            var l = off.left;
            var w = elm.width();
            var docH = $("body").height();
            var docW = $("body").width();
            var isEntirelyVisible = (l + w <= docW);
            if (!isEntirelyVisible) {
                let val = Number(widthOfList) + Number(widthOfSecondList);
                $(this).find('ul:first').css("transform", `translateX(-${val}px)`);
                // console.log('edge');
            } else {
                $(this).removeClass('edge');
                // console.log('non-edge');
            }
        }
    });

}else{
    // Mobile
    $( ".parent-sub").click(function(e) {
        if($(this).hasClass('menu-active')){
            $('.parent-sub').removeClass('menu-active')
        }else{
            $('.parent-sub').removeClass('menu-active')
            $('.show-sub-menu').removeClass('show-sub-menu');
            $(this).addClass('menu-active')
        }
        $(this).find('.sub-menu').toggleClass('show-sub-menu');
        $(this).find('.sub-sub-menu').removeClass('sub-active');
    });

    $( ".sub-sub-menu").click(function(e){
        e.stopPropagation();
        if($(this).hasClass('sub-active')){
            $(this).removeClass('sub-active');
        }else{
            $('.sub-sub-menu').removeClass('sub-active');
            $(this).addClass('sub-active');
        }
    });
    // $('#navbarToggle').on('click', function() {
    //     var primaryNavigation = $('.site-navigation');
    //     // Dropdown toggle setup
    //     if(primaryNavigation.hasClass('mobile-show')) {
    //         primaryNavigation.removeClass('mobile-show');
    //         $('body').removeClass('no-scroll');
    //         $('#navbarToggle').addClass('collapsed');
    //         $('#navbarToggle').attr('aria-expanded', 'false');
    //
    //     } else {
    //         primaryNavigation.addClass('mobile-show');
    //         $('body').addClass('no-scroll');
    //         $('#navbarToggle').removeClass('collapsed');
    //         $('#navbarToggle').attr('aria-expanded', 'true');
    //     }
    // });
}

$('a[href="#"]').on('click', function(e) {
    e.preventDefault();
});

//removes dropdown menu active class when clicking outside of element
$('body').on('click', function(e) {
    var dropdownMenu = $('.show-sub-menu,.parent-sub,.search');
    if(dropdownMenu !== event.target && !dropdownMenu.has(event.target).length){
        $('.parent-sub').removeClass('menu-active');
        $('.sub-menu').removeClass('show-sub-menu');
        $('.sub-sub-menu').removeClass('sub-active');
        $('.js-show').removeClass('show-sub-sub');
        $('.search').removeClass('show-form');
    }
});

$(".search").click(function(e) {
    $(this).toggleClass('show-form');

});

$(".search > form").on('click',function(e){
    e.stopPropagation();
});

(function($) {
    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('.site-navigation');
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('mobile-show')) {
            primaryNavigation.removeClass('mobile-show');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');
            $this.attr('aria-expanded', 'false');

        } else {
            primaryNavigation.addClass('mobile-show');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
            $this.attr('aria-expanded', 'true');
        }
    });
}(jQuery));

$(document).keyup(function(e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
        // console.log('esc');
        if($('.sub-menu').hasClass('show-sub-menu')) {
            $('.sub-menu').removeClass('show-sub-menu');
        }
    }
});

